import React from 'react';
import { Card, CardContent, Typography, TextField, Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import type { AnamnesisData } from '@app-types/visit';
import { Assignment } from '@mui/icons-material';

interface AnamnesisCardProps {
  anamnesis: AnamnesisData;
  onChange: (anamnesis: AnamnesisData) => void;
  disabled?: boolean;
}

const AnamnesisCard: React.FC<AnamnesisCardProps> = React.memo(({ anamnesis, onChange, disabled = false }) => {
  const updateField = <K extends keyof AnamnesisData>(field: K, value: AnamnesisData[K]) => {
    onChange({ ...anamnesis, [field]: value });
  };

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Assignment sx={{ mr: 1, color: 'info.main' }} />
          <Typography variant="h6">Anamneză</Typography>
        </Box>
        
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              label="Alimentație"
              value={anamnesis.nutrition ?? ''}
              onChange={(e) => updateField('nutrition', e.target.value)}
              disabled={disabled}
              placeholder="ex: Royal Canin Junior"
            />
          </Grid>
          
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              label="Deparazitare"
              value={anamnesis.deworming ?? ''}
              onChange={(e) => updateField('deworming', e.target.value)}
              disabled={disabled}
              placeholder="ex: Ultima deparazitare în ianuarie 2025"
            />
          </Grid>
          
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              label="Ultima deparazitare"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={anamnesis.dewormingLast ?? ''}
              onChange={(e) => updateField('dewormingLast', e.target.value)}
              disabled={disabled}
            />
          </Grid>
          
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              label="Medicație curentă"
              value={anamnesis.currentMeds ?? ''}
              onChange={(e) => updateField('currentMeds', e.target.value)}
              disabled={disabled}
              placeholder="ex: Prednisolon 5mg/zi"
            />
          </Grid>
          
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              label="Alergii cunoscute"
              value={anamnesis.allergies ?? ''}
              onChange={(e) => updateField('allergies', e.target.value)}
              disabled={disabled}
              placeholder="ex: Penicilină"
            />
          </Grid>
          
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              label="Mediu"
              value={anamnesis.environment ?? ''}
              onChange={(e) => updateField('environment', e.target.value)}
              disabled={disabled}
              placeholder="ex: Casă cu grădină, contact cu alte animale"
            />
          </Grid>
          
          <Grid size={12}>
            <TextField
              fullWidth
              label="Reproducere"
              value={anamnesis.reproduction ?? ''}
              onChange={(e) => updateField('reproduction', e.target.value)}
              disabled={disabled}
              placeholder="ex: Sterilizat/Nesterilizat, ultima căldură"
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
});

AnamnesisCard.displayName = 'AnamnesisCard';

export default AnamnesisCard;

